import { Linkedin, Facebook, Instagram, Youtube } from "lucide-react";
import { SITE, NAV_LINKS, LOGO, scrollToSection } from "../../config/site";

const SERVICES = [
  "Website Development",
  "Software Development",
  "SaaS Development",
  "Mobile App Development",
  "AI Solutions",
  "Digital Consultancy",
];

const SOCIALS = [
  { icon: Linkedin, label: "LinkedIn", key: "linkedin" },
  { icon: Facebook, label: "Facebook", key: "facebook" },
  { icon: Instagram, label: "Instagram", key: "instagram" },
  { icon: Youtube, label: "YouTube", key: "youtube" },
];

export const Footer = () => (
  <footer className="grain relative bg-ink pt-16" data-testid="main-footer">
    <div className="pointer-events-none absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-gold/50 to-transparent" />
    <div className="relative z-10 mx-auto max-w-7xl px-5 sm:px-8">
      <div className="grid grid-cols-1 gap-12 pb-14 sm:grid-cols-2 lg:grid-cols-[1.4fr_1fr_1fr_1fr]">
        <div>
          <div className="flex items-center gap-3">
            <img src={LOGO} alt="RCS logo" className="h-12 w-12 rounded-full object-cover ring-1 ring-gold/40" />
            <div>
              <p className="font-jakarta text-[15px] font-extrabold tracking-tight text-white">REBHAS CONSULTANCY SERVICES</p>
              <p className="font-mono2 text-[9.5px] uppercase tracking-[0.28em] text-gold-light">{SITE.tagline}</p>
            </div>
          </div>
          <p className="mt-5 max-w-xs font-inter text-[13px] leading-relaxed text-slate-400">
            Custom software, SaaS platforms, School Management ERP, web &amp; mobile apps, AI solutions and digital consultancy.
          </p>
          <div className="mt-6 flex gap-2.5">
            {SOCIALS.map((s) => {
              const url = SITE.social[s.key];
              return url ? (
                <a key={s.key} href={url} target="_blank" rel="noopener noreferrer" aria-label={s.label} data-testid={`footer-social-${s.key}`}
                  className="flex h-9 w-9 items-center justify-center rounded-full border border-white/15 text-slate-400 transition-colors duration-300 hover:border-gold hover:text-gold-light">
                  <s.icon className="h-4 w-4" />
                </a>
              ) : (
                <span key={s.key} title={`${s.label} — link to be added`} aria-label={`${s.label} (coming soon)`} data-testid={`footer-social-${s.key}`}
                  className="flex h-9 w-9 cursor-not-allowed items-center justify-center rounded-full border border-dashed border-white/10 text-slate-600">
                  <s.icon className="h-4 w-4" />
                </span>
              );
            })}
          </div>
        </div>

        <nav aria-label="Footer navigation">
          <p className="font-mono2 text-[10px] font-semibold uppercase tracking-[0.28em] text-slate-500">Navigate</p>
          <ul className="mt-5 space-y-2.5">
            {NAV_LINKS.filter((l) => l.href !== "#process").map((l) => (
              <li key={l.href}>
                <a href={l.href} onClick={(e) => { e.preventDefault(); scrollToSection(l.href); }}
                  data-testid={`footer-nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                  className="font-inter text-[13px] text-slate-400 transition-colors duration-300 hover:text-gold-light">
                  {l.label}
                </a>
              </li>
            ))}
          </ul>
        </nav>

        <div>
          <p className="font-mono2 text-[10px] font-semibold uppercase tracking-[0.28em] text-slate-500">Services</p>
          <ul className="mt-5 space-y-2.5">
            {SERVICES.map((s) => (
              <li key={s}>
                <a href="#services" onClick={(e) => { e.preventDefault(); scrollToSection("#services"); }}
                  data-testid={`footer-service-${s.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                  className="font-inter text-[13px] text-slate-400 transition-colors duration-300 hover:text-gold-light">
                  {s}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <p className="font-mono2 text-[10px] font-semibold uppercase tracking-[0.28em] text-slate-500">Legal</p>
          <ul className="mt-5 space-y-2.5">
            <li><span className="cursor-not-allowed font-inter text-[13px] text-slate-500" title="To be added" data-testid="footer-privacy-link">Privacy Policy</span></li>
            <li><span className="cursor-not-allowed font-inter text-[13px] text-slate-500" title="To be added" data-testid="footer-terms-link">Terms &amp; Conditions</span></li>
          </ul>
          <p className="mt-8 font-mono2 text-[10px] uppercase tracking-[0.22em] text-slate-600">
            {SITE.email || "[ADD OFFICIAL EMAIL]"}
          </p>
        </div>
      </div>

      <div className="flex flex-col items-center justify-between gap-3 border-t border-white/10 py-6 sm:flex-row">
        <p className="font-inter text-[12px] text-slate-500" data-testid="footer-copyright">
          © 2026 REBHAS Consultancy Services. All rights reserved.
        </p>
        <p className="font-mono2 text-[10px] uppercase tracking-[0.24em] text-slate-600">Consulting · Technology · Growth</p>
      </div>
    </div>
  </footer>
);
